export default __webpack_public_path__ + "static/media/Ice 1.ddbabd1b.png";